import { Component, EventEmitter, Input, Output, signal, Signal, SimpleChanges } from '@angular/core';
import { ClientSampleData } from '../../pages/console/sampleData';
import { Router } from '@angular/router';
import { ConsoleTabService } from '../../services/console-tab.service';
import { QuickAddService } from '../../services/quick-add.service';
import { SearchViewModel } from '../../models-views/search.view.model';
import { SearchItem } from '../../models/masterSearch.model';
import { catchError, debounceTime, map, Subject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppCommon } from '../../providers/app-common';

interface AutocompleteOptionGroups {
  type: string;
  count?: number;
  name?: string;
  children?: any;
}

@Component({
  selector: 'app-master-search',
  standalone: false,
  templateUrl: './master-search.component.html',
  styleUrl: './master-search.component.scss'
})
export class MasterSearchComponent {
  @Input() isVisible = false;
  @Output() closeModal = new EventEmitter<boolean>();
  searchValue = '';
  page: number = 1;
  page_size: number = 10;
  optionGroups: AutocompleteOptionGroups[] = [];
  clients = ClientSampleData;
  searchListData: any;
  searchValue$ = new Subject();
  searchByList: any[] = [
    {id: 0, name: 'All', value: 'all', icon: 'bars'},
    {id: 1, name: 'Client', value: 'client', icon: 'apartment'},
    {id: 2, name: 'Project', value: 'project', icon: 'project'},
    {id: 3, name: 'Task', value: 'task', icon: 'reconciliation'},
    {id: 4, name: 'Event', value: 'event', icon: 'calendar'}
  ]
  searchByListSelected: string | null = 'all';
  isLoadingSearch: boolean = false;
  currentUrl: string | undefined;

  constructor(private router: Router, private consoleTab: ConsoleTabService, 
    private quickAddService: QuickAddService, private vm: SearchViewModel) {

    this.vm._searchDataList.subscribe(
      item => {
        this.searchListData = Object.keys(item).map(key => ({
          key,
          value: item[key]
        }));
        this.isLoadingSearch = false;
    });


    this.searchValue$.pipe(debounceTime(500)).subscribe((e: any) => (
      this.vm.getMasterSeacrhList(this.page, this.page_size, this.searchValue, this.searchByListSelected)
    ));

  }

  // onClientClick(item: any, type: any): void {
  //   this.consoleTab.setConsoleType(item, type)
  //   this.router.navigateByUrl('/app/console')
  // }

  ngOnInit(): void {
      this.currentUrl = this.router.url;
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible'].currentValue) {
      this.searchValue = undefined
      this.searchListData = undefined
    }
  }

  redirectToConsole(item: any, tabType: 'client' | 'project' | 'task' | 'event') {
    this.consoleTab.setConsoleTab(item, tabType);
    this.handleCancel();
    if (!this.currentUrl.startsWith('/app/console')) {
      this.router.navigateByUrl('/app/console');
    }
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.closeModal.emit(false);
  }

  showMore(group: AutocompleteOptionGroups) {
    console.log(group)
  }

  clearSearch() {
    this.searchValue = '';
  }

  onSearchChange(e:any){
    this.searchListData = undefined
    // this.searchByListSelected = e;
    this.searchValue = undefined
    this.isLoadingSearch = false;
    this.page = 1;
  }

  onChange(value: string): void {
    // console.log(value);
    if(value.length > 0){
      this.isLoadingSearch = true;
      this.searchValue$.next(this.searchValue)
    } else{
      this.isLoadingSearch = false;
    }
   
  }

  onSearch() {
    // console.log('Searching:', this.searchValue);
    // Add your search logic here
    this.isLoadingSearch = true;
    this.searchValue$.next(this.searchValue);
  }

  openQuickApp(type: any) {
    this.isVisible = false;
    this.searchValue = undefined
    this.closeModal.emit(false);
    this.quickAddService.openQuickAdd(type)
  }

  openReport() {
    this.isVisible = false;
    this.searchValue = undefined
    this.closeModal.emit(false);
    this.router.navigateByUrl('/app/reports')
  }

  openEvent() {
    this.isVisible = false;
    this.searchValue = undefined
    this.closeModal.emit(false);
    this.router.navigateByUrl('/app/events')
  }

  getRegionName(option: any): string {
    try {
      if (option && Array.isArray(option.address) && option.address.length > 0) {
        const region = option.address[0]?.region;
        return region || 'No Region';
      }
      return 'No Address';
    } catch (error) {
      console.error('Error in getRegionName:', error);
      return 'Unknown Region';
    }
  }

  getWebsiteDomain(option: any): string {
    try {
      const url = new URL(option.website);
      return url.hostname; // returns 'www.dell.com'
    } catch (error) {
      console.error('Invalid URL:', error);
      return 'Invalid Domain';
    }
  }

  getProjectStatusColor(status: string): string {
    switch (status) {
      case 'Open': return 'purple';
      case 'In-Progress': return 'blue';
      case 'On-Hold': return 'red';
      case 'Closed': return 'green';
      default: return 'default';
    }
  }

  formatIdToFourDigits(id: number, type: string){
    let fullId = id.toString().padStart(4, '0')
    switch (type) {
      case 'project': return 'PR' + fullId;
      case 'client': return 'CL' + fullId;
      case 'task': return 'TS' + fullId;
      case 'event': return 'EV' + fullId;
      default: return fullId;
    } 
  }

  getIcon(option: any){
    if(!option){
      return
    }
    const thumbnail = option.thumbnail
    if (thumbnail) {
      return thumbnail
    }
    return AppCommon.getDicebearIcon(option.name[0]);
  }

}
